<h1>Search <span style="font-weight: 500;"><em>{{medium}}</em></span></h1>



<form [formGroup]="searchForm">
  <div class="form-group">
    <label for="title-search">Title</label>
    <input type="text" placeholder="Enter search here" class="form-control" id="title-search" formControlName="q">
  </div>

  <div class="form-group">
    <label for="genre-search">Genre</label>
    <!-- <select class="form-control" id="genre-search" formControlName="genre">
      <option value="anime">Anime</option>
      <option value="manga">Manga</option>
    </select> -->
    <div class="btn-group btn-block" id="genre-search">
      <button type="button" class="btn btn-success" (click)="setMedium('anime')">Anime</button>
      <button type="button" class="btn btn-info" (click)="setMedium('manga')">Manga</button>
    </div>
  </div>
  <div class="form-group d-flex justify-content-end">

  </div>
</form>

<div class="row mt-2">
  <div class="col d-flex justify-content-end align-items-center">
    <button type="submit" class="btn btn-light" (click)="goToResult()" [disabled]="searchForm.invalid">
      Search
    </button>
  </div>
</div>

<div class="row mt-2">
  <div class="col d-flex justify-content-end align-items-center">
    <button type="button" class="btn btn-dark" (click)="saveOptions()" [disabled]="searchForm.invalid">
      Save & Search
    </button>
  </div>
</div>


<!-- <button (click)="goToList()" class="btn btn-secondary">Back</button> -->